<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>{{title}}</h2>

<mat-dialog-content>
    <mat-form-field style="width: 300px;">
        <input matInput required="true"
                placeholder="{{placeholder}}"
               [(ngModel)]="stringValue" (keydown.enter)="onEnter($event)">
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="save()" color="primary" mat-raised-button tabindex="-1">SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close tabindex="-1">CANCEL</button>
</mat-dialog-actions>
</div>